import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NamedLink } from '../../../components';
import { typesOfServiceFee } from '../../../util/transaction';

import css from './ServiceFeeItem.css';

const ServiceFeeItem = ({
  state = null,
  createdAt = null,
  firstName = null,
  lastName = null,
  providerName = null,
  providerCountryId = null,
  id = null,
  classNameState,
  serviceFee
}) => {

  const typeOfServiceFeeLabel = typesOfServiceFee.find(({value}) => value === serviceFee.code).label;

  return (
    <li className={css.listItem} key={id}>
      <div className={css.transactionDetails}>
        <div className={css.firstTransactionDetails}>
          <p>
            {firstName} {lastName}
          </p>
          <FormattedMessage id={typeOfServiceFeeLabel} />
          <p className={css.providerName}>
            {providerName} <em className={css.providerCountry}>({providerCountryId})</em>
          </p>
        </div>
        <div className={css.secondTransactionDetails}>
          <p className={classNameState}>{state}</p>
          <p className={css.date}>
            <FormattedMessage id="Console.createdAt" />
            <span> {createdAt}</span>
          </p>
        </div>
      </div>
      <NamedLink className={css.link} name="SaleServiceFeeDetailsPage" params={{ id }}>
        <FormattedMessage id="Console.serviceFeeDetails" />
      </NamedLink>
    </li>
  );
};

export default ServiceFeeItem;
